import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import countryAr from '../../../../utils/country.json';
import FocusControl from '../../../../utils/FocusControl';
import InputField, {
    addOption,
    InputPassword,
    SelectOption,
    TextareaField
} from '../../../../utils/InputField';
import { useAgency } from '../../AgencyProvider';

function ModalCreateAgency() {
    const { handleReload } = useAgency();
    const { setMessage, closeModal } = useTemplate();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { post } = useApi();
    const [formData, setFormData] = useState({
        Organization: '',
        FirstName: '',
        LastName: '',
        Email: '',
        Phone: '',
        Address: '',
        Country: '',
        State: '',
        City: '',
        Zip: '',
        Password: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };

    const handleCreateAgency = (e) => {
        setLoading(true);
        e.preventDefault();
        post('/api/agency', formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                handleReload();
                closeModal();
            })
            .catch((error) => {
                setMessage({ type: 'error', text: error?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);
    return (
        <form
            onSubmit={handleCreateAgency}
            encType="multipart/form-data"
            className="flex flex-col gap-4"
        >
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Smith"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <TextareaField
                label="Address"
                name="Address"
                placeholder='e.g. "1234 Main St"'
                formData={formData}
                onChange={handleChange}
                className="h-16"
                required
            />
            <div className=" flex flex-row gap-x-4">
                <SelectOption
                    label="Country"
                    name="Country"
                    formData={formData}
                    onChange={handleChange}
                    options={countryAr?.map(({ name, code }) => addOption(code, name, code))}
                    required
                />
                <InputField
                    label="Province/State"
                    name="State"
                    placeholder='e.g. "California"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="h-16 flex flex-row gap-x-4">
                <InputField
                    label="City"
                    name="City"
                    placeholder='e.g. "San Francisco"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="ZIP"
                    name="Zip"
                    placeholder='e.g. "94107"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <InputPassword
                label="Default Password"
                name="Password"
                placeholder='e.g. "********"'
                formData={formData}
                onChange={handleChange}
                passGenerate
                required
            />
            <p className="text-sm text-error/90 font-normal leading-6 mb-3">
                Password must contain at least 1 Letter, 1 Number & 1 Symbol. Minimum length is 8
                characters.
            </p>
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Create" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default ModalCreateAgency;
